import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucideBuilding2,
  lucideBuilding,
  lucideUsers,
  lucideCoins,
  lucideAnchor,
  lucideMapPin,
  lucideShip,
  lucideFileText,
  lucideBox,
  lucideCalculator,
  lucideLayoutTemplate,
  lucideReceipt,
  lucideClipboardCheck,
  lucideWarehouse,
  lucideTruck,
  lucideLayers,
} from '@ng-icons/lucide';
import { HlmIcon } from '@spartan-ng/helm/icon';
import { HlmBadge } from '@spartan-ng/helm/badge';

import { PageHeaderComponent, InlineAlertComponent } from '../../../shared/ui/components';
import { OperationalChargesModalComponent } from './operational-charges-modal/operational-charges-modal';
import { ChargeBasisModalComponent } from './charge-basis-modal/charge-basis-modal';
import { PortsModalComponent } from './ports-modal/ports-modal';
import { PortChargesManagementModalComponent } from './port-charges-management-modal/port-charges-management-modal';
import { CarriersManagementModalComponent } from './carriers-management-modal/carriers-management-modal';
import { ContainerLoadTypesModalComponent } from './container-load-types-modal/container-load-types-modal';
import { AgentManagementModalComponent } from '../quotation/agent-management-modal/agent-management-modal';
import { ClientManagementModalComponent } from '../quotation/client-management-modal/client-management-modal';
import { IncotermsManagementModalComponent } from '../quotation/incoterms-management-modal/incoterms-management-modal';
import { AgentPricingModalComponent } from './agent-pricing-modal/agent-pricing-modal';
import { QuoteTemplatesModalComponent } from './quote-templates-modal/quote-templates-modal';
import { VendorDetailsModalComponent } from './vendor-details-modal/vendor-details-modal';
import { CustomsBrokerageModalComponent } from './customs-brokerage-modal/customs-brokerage-modal';
import { WarehouseFeesModalComponent } from './warehouse-fees-modal/warehouse-fees-modal';
import { TruckingChargesModalComponent } from './trucking-charges-modal/trucking-charges-modal';
import { OtherChargesModalComponent } from './other-charges-modal/other-charges-modal';

@Component({
  selector: 'app-forwarding-admin',
  standalone: true,
  // Default CD kept: component has no signals/observables; just ViewChild modal refs.
  imports: [
    CommonModule,
    NgIcon,
    HlmIcon,
    HlmBadge,
    PageHeaderComponent,
    InlineAlertComponent,
    OperationalChargesModalComponent,
    ChargeBasisModalComponent,
    PortsModalComponent,
    PortChargesManagementModalComponent,
    CarriersManagementModalComponent,
    ContainerLoadTypesModalComponent,
    AgentManagementModalComponent,
    ClientManagementModalComponent,
    IncotermsManagementModalComponent,
    AgentPricingModalComponent,
    QuoteTemplatesModalComponent,
    VendorDetailsModalComponent,
    CustomsBrokerageModalComponent,
    WarehouseFeesModalComponent,
    TruckingChargesModalComponent,
    OtherChargesModalComponent,
  ],
  providers: [
    provideIcons({
      lucideBuilding2,
      lucideBuilding,
      lucideUsers,
      lucideCoins,
      lucideAnchor,
      lucideMapPin,
      lucideShip,
      lucideFileText,
      lucideBox,
      lucideCalculator,
      lucideLayoutTemplate,
      lucideReceipt,
      lucideClipboardCheck,
      lucideWarehouse,
      lucideTruck,
      lucideLayers,
    }),
  ],
  templateUrl: './forwarding-admin.html',
  styleUrl: './forwarding-admin.css',
})
export class ForwardingAdminComponent implements OnInit {
  @ViewChild(OperationalChargesModalComponent) operationalChargesModal!: OperationalChargesModalComponent;
  @ViewChild(ChargeBasisModalComponent) chargeBasisModal!: ChargeBasisModalComponent;
  @ViewChild(PortsModalComponent) portsModal!: PortsModalComponent;
  @ViewChild(PortChargesManagementModalComponent) portChargesManagementModal!: PortChargesManagementModalComponent;
  @ViewChild(CarriersManagementModalComponent) carriersManagementModal!: CarriersManagementModalComponent;
  @ViewChild(ContainerLoadTypesModalComponent) containerLoadTypesModal!: ContainerLoadTypesModalComponent;
  @ViewChild(AgentManagementModalComponent) agentManagementModal!: AgentManagementModalComponent;
  @ViewChild(ClientManagementModalComponent) clientManagementModal!: ClientManagementModalComponent;
  @ViewChild(IncotermsManagementModalComponent) incotermsManagementModal!: IncotermsManagementModalComponent;
  @ViewChild(AgentPricingModalComponent) agentPricingModal!: AgentPricingModalComponent;
  @ViewChild(QuoteTemplatesModalComponent) quoteTemplatesModal!: QuoteTemplatesModalComponent;
  @ViewChild(VendorDetailsModalComponent) vendorDetailsModal!: VendorDetailsModalComponent;
  @ViewChild(CustomsBrokerageModalComponent) customsBrokerageModal!: CustomsBrokerageModalComponent;
  @ViewChild(WarehouseFeesModalComponent) warehouseFeesModal!: WarehouseFeesModalComponent;
  @ViewChild(TruckingChargesModalComponent) truckingChargesModal!: TruckingChargesModalComponent;
  @ViewChild(OtherChargesModalComponent) otherChargesModal!: OtherChargesModalComponent;

  showOperationalChargesModal = false;

  ngOnInit(): void {}

  openVendorDetailsModal(): void { this.vendorDetailsModal.open(); }
  openAgentsModal(): void { this.agentManagementModal.open(); }
  openClientsModal(): void { this.clientManagementModal.open(); }

  openOperationalChargesModal(): void { this.showOperationalChargesModal = true; }
  closeOperationalChargesModal(): void { this.showOperationalChargesModal = false; }

  openPortChargesModal(): void { this.portChargesManagementModal.open(); }
  openPortsModal(): void { this.portsModal.open(); }
  openCarriersModal(): void { this.carriersManagementModal.open(); }
  openIncotermsModal(): void { this.incotermsManagementModal.open(); }
  openContainerTypesModal(): void { this.containerLoadTypesModal.open(); }
  openChargeUnitsModal(): void { this.chargeBasisModal.open(); }
  openQuoteTemplatesModal(): void { this.quoteTemplatesModal.open(); }
  openAgentPricingModal(): void { this.agentPricingModal.open(); }
  openCustomsBrokerageFeesModal(): void { this.customsBrokerageModal.open(); }
  openWarehouseFeesModal(): void { this.warehouseFeesModal.open(); }
  openTruckingChargesModal(): void { this.truckingChargesModal.open(); }
  openOtherChargesModal(): void { this.otherChargesModal.open(); }
}
